import React from 'react';

const LoginPage = () => {
  return (
    <div>
      <h2>Iniciar Sesión</h2>
      {/* Aquí construirás tu formulario de login */}
    </div>
  );
};

export default LoginPage;